import { EnhancedCheckboxRHF, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";

import { FC } from "react";
import { Grid } from "@mui/material";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";

interface IDeductionsSetupFieldsPanel {
  deductionsFieldsList: IDropDownListResponse[]
}
export const DeductionsSetupFieldsPanel: FC<
  IDeductionsSetupFieldsPanel
> = ({ deductionsFieldsList }) => {
  return (
    <>
      {deductionsFieldsList && deductionsFieldsList.length > 0 && deductionsFieldsList.map((item: any) => {
        return (
          <RHookFormNumberFieldWithLabel id={`${item.value}-deductions`} testId={`${item.label}`} label={`${item.label}`} />
        )
      })}
    </>
  );
};
